import React, { useEffect, useState } from 'react';
import Footer from '../../components/Footer/Footer';
import Header from '../../components/Header/Header';
import { Box, Grid2, Typography } from "@mui/material";
import axios from 'axios'
import './News.css'
import { useParams } from 'react-router-dom';
import CalendarTodayIcon from '@mui/icons-material/CalendarToday';
import parse from 'html-react-parser';

const News: React.FC = () => {
      const [dataNews, setNews] = useState<
        Array<{
          slug: string
          name: string
          description?: string
          divData?: any
          h1?: string
          date?: string
          text?: string
          textbt?: string
            elementList?: Array<{
                title: string
                text: string
            }>
            RepetableArgumetns?: Array<{
                argumentTitle: string
                argumentText: string
                ArgumentSubItem: string
            }>
          }>
      >([])
    
      useEffect(() => {
        axios
          .get('https://app.dfopsa.online/api/news-page-apis?populate[newspageapi][populate]=*')
          .then(res => {
            const raw = res?.data?.data
            console.log('Raw News Data:', raw)
            
                const simplified = raw
                .map((item: any) => {
                    const api = item?.newspageapi?.[0]; // accesezi primul obiect din listă

                    if (!api) return null; // protecție în caz că lista e goală

                    return {
                    slug: api.slug,
                    name: api.name,
                    description: api.description,
                    h1: api.h1,
                    date: api.date,
                    text: api.text,
                    divData: api.divData,
                    textbt: api.textbt,
                    elementList: api?.elementList?.map((el: any) => ({
                        title: el.title,
                        text: el.text,
                    })),
                    RepetableArgumetns: api?.RepetableArgumetns?.map((arg: any) => ({
                        argumentTitle: arg.argumentTitle,
                        argumentText: arg.argumentText,
                        ArgumentSubItem: arg.ArgumentSubItem,
                    })),
                    };
                })
                .filter(Boolean); // elimină itemii null (fără newspageapi)

            setNews(simplified)
          })
          .catch(err => console.error('Failed to fetch news:', err))
      }, [])

  const { slug } = useParams()
  const newsItem = dataNews.find(item => item.slug === slug)
  const htmldivData = newsItem?.divData || ""; // fallback la string gol

  if (!newsItem) {
    return <Typography>Loading...</Typography>
  }

    return (
            <Box className="news-page">
            <Header />

                <Box
                    sx={{ minHeight: 800, mx: 18, my: 2}}
                    className="newsPageContainer"
                >
                    <Box mt={15}>
                        <Typography variant="h3" className="titleNews"     
                        sx={{ width: '1200px', wordWrap: 'break-word', fontWeight: 'bold' }}
                    >
                            {newsItem.name}
                        </Typography>
                    </Box>
                    {newsItem.date && (
                    <Box 
                        sx={{    
                        display: 'flex',
                        alignItems: 'center',
                        paddingLeft: 2,
                        marginTop: 4,
                        marginBottom: 4,
                        }} 
                        mx="auto" className="TimeDispl"
                    >
                        
                        <CalendarTodayIcon sx={{ fontSize: 16, color: '#555', mr: 1 }} />
                        <Typography sx={{fontSize: '20px' }}>{newsItem.date}</Typography>
                    </Box>
                    )}
                    <Box mt={2} mb={2} mx="auto" className="newsContent">
                        <Typography>{newsItem.description}</Typography>
                    </Box>
                    <Box mt={2} mb={2} mx="auto" className="newsContent">
                        <Typography component="div">
                            {parse(htmldivData)}
                        </Typography>
                    </Box>

                    <Box mt={2} mb={2} mx="auto" className="newsContent">
                        <Typography>{newsItem.text}</Typography>
                    </Box>


                    <Typography className="subtitleNews">{newsItem.h1}</Typography>

                        <Box className="newsElements" component="ol" sx={{ listStyle: 'none', paddingLeft: 0 }}>
                        {newsItem?.elementList?.map((el, index) => (
                            <Box
                            component="li"
                            key={index}
                            className="newsElement"
                            sx={{
                                display: 'flex',
                                alignItems: 'flex-start',
                                marginBottom: 2,
                                marginLeft: 5,
                            }}
                            >
                            <Box
                                sx={{
                                    width: 8,
                                    height: 8,
                                    borderRadius: '50%',
                                    backgroundColor: '#FFB300',
                                    marginTop: '8px',
                                    marginRight: 1.5,
                                    flexShrink: 0,
                                }}
                            />
                            <Box sx={{ mr: 55 }}>
                                <Typography component="span" fontWeight="bold">
                                {el.title}
                                </Typography>
                                <Typography component="span"> {el.text}</Typography>
                            </Box>
                            </Box>
                        ))}
                        </Box>
                        <Box >
                        {newsItem?.RepetableArgumetns?.map((arg, index) => (
                            <Box
                            mt={4} 
                            key={index}
                            className="newsArgument"
                            sx={{
                                display: 'flex',
                                flexDirection: 'column',
                            }}
                            >
                            <Typography component="span" fontWeight="bold">
                                {arg?.argumentTitle}
                            </Typography>

                            <Typography component="span" mt={1}>
                                {parse(arg?.argumentText)}
                            </Typography>
                                <Box
                                sx={{
                                    display: 'flex',
                                    alignItems: 'flex-start',
                                    borderLeft: '4px solid #ccc', // vertical line
                                    paddingLeft: 2, // space between line and text
                                    marginTop: 1.5,
                                    marginLeft: 4, // indent
                                }}
                                >
                                <Typography component="span">
                                    {arg.ArgumentSubItem}
                                </Typography>
                                </Box>
                            </Box>
                        ))}
                        </Box>
                    <Box mt={4} mb={2} mx="auto" className="textBt">
                     <Typography>{newsItem.textbt}</Typography>
                    </Box>
                </Box>

            <Footer />
            </Box>
    );
};

export default News;